export const PICE_ARR = [
  {
    title: "기억의 조각 #1",
    content: `
      의뢰인은 종종<br>
      <span class="txtW700">살롱 in 양재천</span> 거리를 산책하며<br>
      마음을 다잡곤 했다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #2",
    content: `
      의뢰인은 오전 잔고 정산이 끝나면<br/> 가방 안에 있는 <span class="txtW700">마들렌</span><br/>한 개를 꺼내 먹곤 했다.
    `,
    status: "ok",
    keyText: "핵심 단서 #1 : 양",
  },
  {
    title: "기억의 조각 #3",
    content: `
      의뢰인이 마들렌을 사는 곳은<br/><span class="txtW700">우쿠</span>였다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #4",
    content: `
      의뢰인은 <span class="txtW700">와인</span>은 마시지 못하지만,<br/>색깔과 향을 좋아했다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #5",
    content: `
      의뢰인은 가끔<br/>와인 수입 전문 업체<br/><span class="txtW700">크로스비</span>에서 와인을 구경했다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #6",
    content: `
      의뢰인은 이전에<br/>양재천 <span class="txtW700">수변무대</span>에 열리는<br/>작은 클래식 공연을 보러 갔다.
    `,
    status: "ok",
    keyText: "핵심 단서 #2 : 르",
  },
  {
    title: "기억의 조각 #7",
    content: `
      의뢰인의 친구는 그의 옆에서<br/><span class="txtW700">모자</span>를 눌러 쓰고<br/>클래식 공연을 함께 보았다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #8",
    content: `
      수변무대를 구경하다가<br/>의뢰인은 감기에 걸렸고,<br/>친구는 혼자 사는<br/>의뢰인을 챙겨주었다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #9",
    content: `
      감사의 의미로<br/>의뢰인은 친구에게<br/>며칠 뒤 <span class="txtW700">블레숑</span> 매장에서<br/>모자를 사서 주었다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #10",
    content: `
      의뢰인은 친구와<br/><span class="txtW700">에떼</span> 와인바에 자주 갔다.<br/>술은 먹지 않았지만<br/>레드와인의 빨간색이 좋았다.
    `,
    status: "ok",
    keyText: "핵심 단서 #3 : 재",
  },
  {
    title: "기억의 조각 #11",
    content: `
      의뢰인은 <span class="txtW700">그린 몬스터</span> 앞을<br/>지날 때마다 친구가 생각나서<br/>싱긋 웃곤 했다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #12",
    content: `
      의뢰인 양서초는<br/>점심이면 가끔 친구를 불러<br/><span class="txtW700">한양 돈까스</span>에서 돈까스를 먹었다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "기억의 조각 #13",
    content: `
      의뢰인 양서초는<br/>친구의 승진 소식을 듣고<br/>모임에서 만나면 줄 생각으로<br/><span class="txtW700"><봄이 옵니다. 플라워></span>에서<br/>노랑 호접란을 사갔다.
    `,
    status: "ok",
    keyText: "핵심 단서 #4 : 옹",
  },
  {
    title: "기억의 조각 #14",
    content: `
      양재르옹은 의뢰인 양서초가<br/>기억을 잃기 전 만나기로 했던<br/>친한 친구이다.
    `,
    status: "none",
    keyText: "",
  },
  {
    title: "의뢰인의 정보",
    content: `
      &nbsp;&nbsp;&nbsp;<span class='dotIn'></span>의뢰인의 이름은 양서초<br/>...
    `,
    status: "none",
    keyText: "",
  },
];
